/**
 * We considered letting BE build the CookieFirst URL, but BE has no extra knowledge:
 * it would just echo the request hostname with the token. For the kinds of URL format
 * changes we’ve seen so far, centralization only adds indirection.
 *
 * For now FE builds the URL; if BE later owns mappings or manages the domains
 * configured in CookieFirst, this decision should be revisited.
 */
export const createCookieFirstScriptUrl = ({ hostname, apiKey }: { hostname: string; apiKey: string }) =>
    `https://consent.cookiefirst.com/sites/${hostname}-${apiKey}/consent.js`;
